export class DrugToDrugInteractionModel {
  public selectedIngredientId: number;
  public selectedIngredientName: string;
  public interactionIngredientId: number;
  public interactionIngredientName: string;
  public interactionIngredientBrandNames: string;
  public interactionTypeId: number;
  public consumerDecscription: string;
  public professionalDecscription: string;
}